import React from "react";
import { json, type LoaderFunctionArgs, type ActionFunctionArgs } from "@remix-run/node";
import { useLoaderData, useFetcher, useRevalidator } from "@remix-run/react";
import { AppProvider } from "@shopify/polaris";
import { PublicDashboardView } from "../components/PublicDashboardView";
import { restoreSnapshot } from "../services/seed.server";
import { ENTERPRISE_PLAN } from "../constants";
import enTranslations from "@shopify/polaris/locales/en.json";
import demoData from "../data/public_demo_data.json";

export const links = () => [
  { rel: "stylesheet", href: "https://unpkg.com/@shopify/polaris@12.0.0/build/esm/styles.css" }
];

export const loader = async ({ request }: LoaderFunctionArgs) => {
  const shop = "revivify-demo.myshopify.com"; 

  try {
    return json({
      ...demoData,
      planName: ENTERPRISE_PLAN,
      appEnv: "prod",
      isAdmin: false,
      isDemoMode: true,
      isReadOnly: true,
      isReviewerStore: false,
      rechargeConnected: true,
      loopConnected: true,
      usageLimitReached: false,
      usageWarning: false,
      supportTickets: [],
      recordCount: demoData.returns.length,
      sessionShop: shop,
      shopHandle: "revivify-demo",
      shopLocale: "en-US",
      shopCurrency: "USD",
      shopTimezone: "UTC",
      noSubscriptionReturns: [],
      justSubscribed: false,
    });
  } catch (error: any) {
    console.error("[DEMO_LOADER_CRASH]", error);
    throw error;
  }
};

export const action = async ({ request }: ActionFunctionArgs) => {
  const shop = "revivify-demo.myshopify.com";
  const formData = await request.formData();
  const actionType = formData.get("actionType") as string;

  if (actionType === "RESTORE_DEMO_DATA") {
    const result = await restoreSnapshot(shop, "BASELINE");
    return json(result);
  }

  return json({ success: false, error: "Action not permitted in public demo." });
};

export default function DemoPage() {
  const data = useLoaderData<typeof loader>();
  const fetcher = useFetcher();
  const revalidator = useRevalidator();
  const [mounted, setMounted] = React.useState(false);
  const [lastRefreshed, setLastRefreshed] = React.useState(new Date());

  React.useEffect(() => {
    setMounted(true);
    setLastRefreshed(new Date());
  }, []);

  return (
    <AppProvider i18n={enTranslations}>
      <div style={{ background: "#f6f6f7", minHeight: "100vh" }}>
        <PublicDashboardView
          {...data}
          mounted={mounted}
          lastRefreshed={lastRefreshed}
          revalidator={revalidator}
          fetcher={fetcher}
          downloadFetcher={{ state: 'idle' }}
          downloadAllFetcher={{ state: 'idle' }}
          onOpenSupport={() => {}}
          onNavigate={() => {}}
          onThresholdChange={() => {}}
          onDownloadCSV={() => {}}
          onDownloadAllCSV={() => {}}
          onDeleteHistory={() => {}}
          onSubmitFeedback={() => {}}
          onDeleteTicket={() => {}}
        />
      </div>
    </AppProvider>
  );
}
